import * as React from 'react';
import moment from 'moment';
import CartMessages from '../../components/cart/cart-messages';
import { UnseatedFlexCartItemsProps, UnseatedFlexCartItemGroupViewProps } from '../../components/cart/unseated-flex-cart-Items';
import UnseatedFlexCartItem from '../../components/cart/unseated-flex-cart-item';


const UnseatedFlexCartItemGroupView: React.StatelessComponent<UnseatedFlexCartItemGroupViewProps> = props => {
    const anyPerformances = props.cartItems.length > 0;
    const seatMapItem = props.cartItems.sort((a, b) => { return a.cartItemId - b.cartItemId })[0];
    return (
        anyPerformances &&
        <div className={"stack ace-subs-cart-listing"}>
            <ul className="ace-subs-cart-summary">
                {
                    props.cartItems.sort((a, b) => { return a.cartItemId - b.cartItemId }).map((item, index) =>
                        <UnseatedFlexCartItem key={item.cartItemId} itemId={item.cartItemId}
                            selectedZoneId={item.selectedZoneId}
                            hideSeatMap={true}
                            showSeatMapOnly={false}
                            showTitleAndRemoveButton={true}
                            showZoneDropdown={index == props.cartItems.length - 1}
                        />
                    )
                }
            </ul>
            {

                <UnseatedFlexCartItem key={seatMapItem.cartItemId} itemId={seatMapItem.cartItemId}
                    selectedZoneId={seatMapItem.selectedZoneId}
                    hideSeatMap={false}
                    showSeatMapOnly={true}
                />

                }

            {
                props.groupName.length > 0 ?
                    <>
                        <div className="stack-xs">
                            <p className="bold" data-demo-label="Performance Group Description">{props.groupName}</p>
                            <CartMessages performanceGroupId={props.groupId} />
                        </div>
                    </>
                    : null
            }


            <ul className="ace-subs-cart stack">
                {
                    props.cartItems.sort((a, b) => { return a.cartItemId - b.cartItemId }).map((item, index) =>
                        <UnseatedFlexCartItem key={item.cartItemId} itemId={item.cartItemId}
                            selectedZoneId={item.selectedZoneId}
                            hideSeatMap={true}
                            showZoneDropdown={index == props.cartItems.length - 1}
                        />
                    )
                }
            </ul>
        </div>
    )
}

const CartItemsView: React.StatelessComponent<UnseatedFlexCartItemsProps> = props => {

    return (
        <>
            {
                props.requiresPerformanceGroups ?
                    props.performanceGroups.map(pg => {
                        const groupPerfIds = pg.tessPerformances.map(p => p.performanceId);
                        const groupPerformances = props.cartItems.filter(p => groupPerfIds.indexOf(p.cartItemId) >= 0);
                        return <UnseatedFlexCartItemGroupView key={pg.id} text={props.text}
                            cartItems={groupPerformances}
                            performanceMin={pg.minimumPerformances}
                            groupName={pg.description} groupId={pg.id} />
                    })
                    :
                    <UnseatedFlexCartItemGroupView
                        text={props.text} performanceMin={props.packageMin}
                        groupId={null} groupName="" cartItems={props.cartItems}
                    />

            }

        </>
    );
}

export default CartItemsView;